const initState = {
  campaign_type: null, // 计划类型
  daily_budget: null,
  total_budget: null,
  product_type: null, // 推广目标
  speed_mode: null, // 投放形式
  campaign_name: null,
  dailyBudgetSelect: null,
  totalBudgetSelect: null
}
const state = {
  ...initState,
  initState() {
    return initState
  }
}
const mutations = {
  initCreatePlanState(state) {
    for (const key in initState) {
      state[key] = initState[key]
    }
  },
  getCampaignType(state, data) {
    state.campaign_type = data
    console.log(state.campaign_type, '我是campaign_type')
  },
  getDailyBudget(state, data) {
    state.daily_budget = data
    console.log(state.daily_budget, '我是daily_budget')
  },
  getTotalBudget(state, data) {
    state.total_budget = data
    console.log(state.total_budget, '我是total_budget')
  },
  getProductType(state, data) {
    state.product_type = data
    console.log(state.product_type, '我是product_type')
  },
  getSpeedMode(state, data) {
    state.speed_mode = data
    console.log(state.speed_mode, '我是speed_mode')
  },
  getCampaignName(state, data) {
    state.campaign_name = data
    console.log(state.campaign_name, '我是campaign_name')
  },
  getDailyBudgetSelect(state, data) {
    state.dailyBudgetSelect = data
    console.log(state.dailyBudgetSelect, 'dailyBudgetSelect选项')
  },
  getTotalBudgetSelect(state, data) {
    state.totalBudgetSelect = data
    console.log(state.totalBudgetSelect, 'totalBudgetSelect选项')
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
